/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentGeneratorRepresentation
 */
export interface DocumentGeneratorRepresentation {
    /**
     * Identifier of the generator.
     * @type {string}
     * @memberof DocumentGeneratorRepresentation
     */
    key: string;
    /**
     * Name of the generator.
     * @type {string}
     * @memberof DocumentGeneratorRepresentation
     */
    name: string;
    /**
     * Identifier of the park where the generator belongs to.
     * @type {string}
     * @memberof DocumentGeneratorRepresentation
     */
    parkKey: string;
    /**
     * Name of the park where the generator belongs to.
     * @type {string}
     * @memberof DocumentGeneratorRepresentation
     */
    parkName: string;
}

/**
 * Check if a given object implements the DocumentGeneratorRepresentation interface.
 */
export function instanceOfDocumentGeneratorRepresentation(value: object): value is DocumentGeneratorRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('parkKey' in value) || value['parkKey'] === undefined) return false;
    if (!('parkName' in value) || value['parkName'] === undefined) return false;
    return true;
}

export function DocumentGeneratorRepresentationFromJSON(json: any): DocumentGeneratorRepresentation {
    return DocumentGeneratorRepresentationFromJSONTyped(json, false);
}

export function DocumentGeneratorRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentGeneratorRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'parkKey': json['parkKey'],
        'parkName': json['parkName'],
    };
}

export function DocumentGeneratorRepresentationToJSON(json: any): DocumentGeneratorRepresentation {
    return DocumentGeneratorRepresentationToJSONTyped(json, false);
}

export function DocumentGeneratorRepresentationToJSONTyped(value?: DocumentGeneratorRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'parkKey': value['parkKey'],
        'parkName': value['parkName'],
    };
}

